import {DisposalSet} from '@neptune/cx/utils';
import { registerFragment } from '@neptune/cx/registry';

import './styles.scss';

const gc = new DisposalSet();

registerFragment('chroa-sticky-zone', (fragmentEl) => {
    const isEditMode = document.body.classList.contains('has-edit-mode-menu');

    /*
     * The sticky behaviour itself is pure CSS (position: sticky on the wrapper).
     * Here we only handle the empty state: if an author has not dropped anything
     * into the sticky zone, hide it in view mode so it doesn't reserve a column.
     *
     * In view mode Liferay replaces <lfr-drop-zone> with the rendered fragments
     * (each wrapped in a .lfr-layout-structure-item-* element), so we detect
     * content by looking for such a wrapper rather than for the drop zone itself.
     */
    const stickyZone = fragmentEl.querySelector('.chroa-sticky-zone__sticky') as HTMLElement | null;

    if (!isEditMode && stickyZone) {
        const hasContent = stickyZone.querySelector('[class*="lfr-layout-structure-item"]') !== null;

        if (!hasContent) {
            stickyZone.style.display = 'none';
        }
    }
});

if (import.meta.hot) {
    import.meta.hot.accept();
    import.meta.hot.dispose(() => gc.disposeAll());
}
